import { type ReactElement, useState } from 'react'
import { GoogleMapProvider } from '@components'
import { type UseFormReturnType } from '@mantine/form'
import { type TeamData } from '@terros/common'
import { type SelectedPlace } from 'app/components/team/editTeam/types'
import { EditTeamForm } from './EditTeamForm'

type Props = {
  form: UseFormReturnType<TeamData>
}
export const EditTeamDrawerForm = ({ form }: Props): ReactElement => {
  const [selectedPlace, setSelectedPlace] = useState<SelectedPlace>()

  return (
    <GoogleMapProvider>
      <EditTeamForm form={form} selectedPlace={selectedPlace} setSelectedPlace={setSelectedPlace} />
    </GoogleMapProvider>
  )
}
